import { render } from "./BankAccountsTable.vue?vue&type=template&id=3d8c771f&scoped=true"
import script from "./BankAccountsTable.vue?vue&type=script&lang=js"
export * from "./BankAccountsTable.vue?vue&type=script&lang=js"

import "./BankAccountsTable.vue?vue&type=style&index=0&id=3d8c771f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8c771f"]])

export default __exports__